"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var clsx_1 = __importDefault(require("clsx"));
function Button(props) {
    var text = props.text, disabled = props.disabled, type = props.type, onClick = props.onClick, dataCy = props.dataCy;
    return (react_1.default.createElement("button", { type: "button", className: (0, clsx_1.default)("eva-button eva-".concat(type, "-button"), 'center-content'), disabled: disabled, onClick: onClick, "data-cy": dataCy },
        react_1.default.createElement("span", { className: "eva-button__text" },
            " ",
            text)));
}
exports.default = Button;
